export const navLinks = [
  { id: "features", label: "核心能力", icon: "ri-flashlight-line" },
  { id: "guide", label: "订阅方式", icon: "ri-list-check-2" },
  { id: "scenes", label: "适用场景", icon: "ri-focus-2-line" },
  { id: "stories", label: "用户评价", icon: "ri-chat-quote-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-line" },
];

export const heroStats = [
  { value: "12.6万+", label: "活跃订阅用户", icon: "ri-user-heart-line" },
  { value: "98.6%", label: "推送准时送达", icon: "ri-check-double-line" },
  { value: "3秒内", label: "新料第一时间触达", icon: "ri-rocket-line" },
  { value: "24小时", label: "全天候更新监测", icon: "ri-time-line" },
];

export const features = [
  {
    title: "即时推送通知",
    desc: "关注内容一有更新，推送通知立刻送达，无需反复刷新页面，新料动态实时掌握。",
    icon: "ri-notification-4-line",
    tag: "核心能力",
  },
  {
    title: "智能订阅管理",
    desc: "按栏目、话题或关键词自由组合订阅，一处管理所有关注源，订阅提醒清晰不混乱。",
    icon: "ri-stack-line",
    tag: "订阅管理",
  },
  {
    title: "更新提醒快人一步",
    desc: "在别人还在手动刷新时，你已经收到更新提醒，始终走在最新动态的前沿。",
    icon: "ri-timer-flash-line",
    tag: "先人一步",
  },
  {
    title: "内容指纹去重",
    desc: "内置智能去重机制，相同或近似内容只提醒一次，避免被重复推送打扰。",
    icon: "ri-shield-check-line",
    tag: "清爽无扰",
  },
];

export const steps = [
  {
    no: "01",
    title: "选择关注内容",
    desc: "从栏目、作者或关键词中，勾选你真正关心的内容方向，建立个人订阅清单。",
    icon: "ri-list-settings-line",
  },
  {
    no: "02",
    title: "完成订阅确认",
    desc: "填写常用邮箱，点击邮件中的确认链接即可完成订阅，整个过程不到一分钟。",
    icon: "ri-mail-check-line",
  },
  {
    no: "03",
    title: "静候推送通知",
    desc: "订阅后无需任何操作，新料一经更新，推送通知会第一时间主动送达。",
    icon: "ri-send-plane-line",
  },
];

export const scenes = [
  {
    title: "追更作者动态",
    desc: "喜欢的作者或创作者一旦发布新内容，立刻收到更新提醒，第一时间追更不落空。",
    icon: "ri-bard-line",
    tint: "primary",
  },
  {
    title: "蹲守限量上新",
    desc: "限量资源与新料往往很快被抢空，订阅提醒帮你抢在别人前面看到消息。",
    icon: "ri-fire-line",
    tint: "accent",
  },
  {
    title: "跟进行业资讯",
    desc: "持续跟踪某类行业动态与专题更新，定期收拢最新内容，不再漏掉关键信息。",
    icon: "ri-funds-box-line",
    tint: "primary",
  },
  {
    title: "追踪关键词话题",
    desc: "按关键词或话题订阅，凡是命中你兴趣的新内容都会通过推送通知送达。",
    icon: "ri-search-eye-line",
    tint: "accent",
  },
];

export const channels = [
  { label: "站点栏目订阅", icon: "ri-window-2-line" },
  { label: "作者 / 频道主页", icon: "ri-user-follow-line" },
  { label: "话题与标签", icon: "ri-hashtag" },
  { label: "搜索关键词", icon: "ri-search-line" },
  { label: "RSS 订阅源", icon: "ri-rss-line" },
  { label: "邮件推送通知", icon: "ri-mail-send-line" },
  { label: "站内动态提醒", icon: "ri-megaphone-line" },
  { label: "自定义订阅规则", icon: "ri-route-line" },
];

export const reviews = [
  {
    name: "林同学",
    role: "内容追更用户",
    quote:
      "以前总是隔三差五自己刷新，常常错过关键更新。用了订阅提醒后，新料一到马上收到推送通知，再也没漏过想看的更新。",
    initials: "林",
    tint: "primary",
  },
  {
    name: "阿K",
    role: "行业信息收集者",
    quote:
      "把关注的几个栏目和关键词都订阅了，更新提醒会自己找上门。智能去重很贴心，不会被同一条消息反复打扰，体验很清爽。",
    initials: "K",
    tint: "accent",
  },
  {
    name: "一舟",
    role: "数码爱好者",
    quote:
      "蹲守限量上新最需要的就是速度，订阅后基本三秒内就能收到推送，让我总是快人一步，抢到了好几次先机。",
    initials: "舟",
    tint: "secondary",
  },
];

export const faqs = [
  {
    q: "看料是做什么的服务？",
    a: "看料是一款内容更新订阅与推送提醒服务。你只需要选择自己关心的栏目、作者或话题并完成订阅，之后相关内容一旦有新料更新，我们就会通过推送通知第一时间提醒你，让你不再错过任何一次更新。",
  },
  {
    q: "订阅之后会通过什么方式收到推送？",
    a: "订阅确认完成后，你可以通过邮件推送、站内动态提醒等方式接收新料通知。默认会主动推送更新提醒，你也可以在个人设置中调整提醒渠道与接收频率。",
  },
  {
    q: "会不会错过关键的新料更新？",
    a: "不会。看料的更新监测全天候运行，只要所订阅内容出现新料，推送通知就会在极短时间内送达。加上刷新提醒与订阅提醒的双重保障，即使忙到没空查看，也能在回到页面后第一时间补齐错过的动态。",
  },
  {
    q: "订阅是否需要付费？",
    a: "基础订阅与推送提醒功能免费开放，让每位用户都能体验到不错的服务。若后续推出更高频提醒或更多订阅名额的进阶选项，会以清晰、透明的规则提前说明。",
  },
  {
    q: "可以随时取消订阅吗？",
    a: "可以。订阅管理完全自由，你可以在任意时间停用某些内容或彻底取消订阅，相关提醒会立即停止，不会产生任何绑定或费用负担。",
  },
  {
    q: "如何避免推送太多打扰到自己？",
    a: "你可以在订阅管理中选择关注的内容粒度，并用内置去重机制过滤近似内容。同时支持按重要程度分配提醒优先级，把更新提醒交给你真正在意的内容，减少无关打扰。",
  },
];

export const footerColumns = [
  {
    title: "产品功能",
    links: [
      { label: "核心能力", href: "#features" },
      { label: "订阅方式", href: "#guide" },
      { label: "适用场景", href: "#scenes" },
      { label: "立即订阅", href: "#subscribe" },
    ],
  },
  {
    title: "帮助与支持",
    links: [
      { label: "常见问题", href: "#faq" },
      { label: "用户评价", href: "#stories" },
      { label: "订阅来源", href: "#channels" },
      { label: "联系邮箱", href: "#subscribe" },
    ],
  },
];